import { useQuery } from "@tanstack/react-query";
import { fetchGoodsSearch } from "@/lib/services/goodsSearchService";

/**
 * React Query hook for goods search within a storage.
 * @param storageId - Storage ID to search in
 * @param query - Search query (minimum 3 characters)
 */
export function useGoodsSearch(storageId: number | null, query: string) {
    return useQuery({
        queryKey: ["goodsSearch", storageId, query],
        queryFn: () => fetchGoodsSearch(storageId!, query),
        enabled: !!storageId && !!query && query.length >= 3,
        staleTime: 2 * 60 * 1000, // 2 minutes
    });
}
